var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
var PlasticItem = function (props) {
    var plastic = props.plastic;
    return (_jsxs("div", __assign({ className: 'plastic-item' }, { children: [_jsx("div", __assign({ className: 'plastic-item__hash' }, { children: plastic.Hash })), _jsx("button", __assign({ className: 'plastic-item__delete', onClick: function () { return props.plasticDelete(plastic.Id); } }, { children: "\u041E\u0442\u0432\u044F\u0437\u0430\u0442\u044C \u043A\u0430\u0440\u0442\u0443" }))] })));
};
PlasticItem.propTypes = {
    plastic: PropTypes.object.isRequired,
    plasticDelete: PropTypes.func.isRequired
};
export default PlasticItem;



// WEBPACK FOOTER //
// ./src/components/cards/PlasticItem.jsx